<template>
<div style="max-height:250px;overflow-y:auto;overflow-x:hidden">
    <a v-for="file in fileElements" target="_blank" :href="file.value" class="transparent" :key="file.key">
    <div  class="workflow-file hover-darken clickable" :key="file.key" @click="fileClicked(file)">
        <v-icon v-if="!file.loading" color="grey" style="float:left;margin-right:5px">attachment</v-icon>
        <v-progress-circular v-if="file.loading" style="float:left;margin-right:5px" :size="20" :width="2" indeterminate class="grey--text"></v-progress-circular>
        
        <div style="float:right" @click.stop.prevent>

        <v-menu bottom left :nudge-width="200">
        <template v-slot:activator="{ on }">
        <v-icon style="margin-right:11px;" v-on="on" color="grey">keyboard_arrow_down</v-icon>
        </template>
        <v-list> 
            <v-list-item @click="$emit('menu', 'delete', file)"> 
                <v-list-item-title>Delete</v-list-item-title>
            </v-list-item>            
            <v-list-item @click="$emit('menu', 'email', file)"> 
                <v-list-item-title>Email</v-list-item-title>
            </v-list-item>            
        </v-list>
        </v-menu>
        </div>
        
        
        
        <div class="truncate" style="padding-top:2px">{{file.title}}</div>

    </div>
    </a>
</div>
</template>

<script>
export default {
    data() {
        return {
        
        }
    },
    
    props: {
        fileElements: Array,
    },

    computed: {
        attributes() {

        }
    },

    methods: {
        fileClicked(file) {
            console.log('File clicked', file)
        }
    }
}
</script>

<style scoped>

.workflow-file {
    border:solid 1px transparent;
    border-radius:3px;
    display:inline-block;
    width:100%; height:35px;
    overflow: hidden;
    margin: 0px 0px 5px 9px;
    /* background-color:#e5e5e5; */
    /* background-color:#e5e5e5; */
    padding:4px;
    color:#666;
}

.workflow-file:hover {
    background-color:#eee;
}
   
</style>




// WEBPACK FOOTER //
// TransactionFiles.vue?3d6c86f3